/* eslint-disable react/prop-types */
import React from 'react';
import { components } from 'react-select';

const DropdownIndicator = (props: components.DropdownIndicator) => {
  return (
    <components.DropdownIndicator {...props}>
      <img src="/images/chevronDownBlack.svg" />
    </components.DropdownIndicator>
  );
};

export default DropdownIndicator;
